import { Component, Input, OnDestroy } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { MatOption } from '@angular/material/autocomplete';
import { MatFormField } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatSelect } from '@angular/material/select';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { MatSlider, MatSliderThumb } from '@angular/material/slider';
import { VoiceEmotion } from '@heygen/streaming-avatar';
import { Subscription } from 'rxjs';

import { TBotItem } from '@core/interfaces/TBotItem';

import { MetadataService, MetadataSlugs } from '@shared/services/metadata.service';

@Component({
    selector: 'app-talking-avatar-settings',
    templateUrl: './talking-avatar-settings.component.html',
    styleUrls: ['./talking-avatar-settings.component.scss'],
    standalone: true,
    imports: [
      ReactiveFormsModule,
      MatSlideToggle,
      MatFormField,
      MatInput,
      MatSlider,
      MatSliderThumb,
      MatSelect,
      MatOption,
    ],
})
export class TalkingAvatarSettingsComponent implements OnDestroy {
  private subs: Subscription[] = [];
  protected avatarConfigForm = this.fb.group({
    isAvailable: [false],
    avatarId: [''],
    voiceRate: [1],
    voiceEmotion: [VoiceEmotion.BROADCASTER],
  });
  protected botItem: TBotItem | undefined;
  protected voiceEmotions = Object.values(VoiceEmotion);
  @Input({ required: true })
  public set bot(bot: TBotItem) {
    this.botItem = bot;
    this.subs.push(
      this._metadataService.get<string>(this.getMetadataKey()).subscribe(metadata => {
        if (metadata.value) {
          const avatarConfig = JSON.parse(metadata.value);
          this.avatarConfigForm.patchValue(avatarConfig);
        }
      })
    );
  }

  constructor(
    private fb: FormBuilder,
    private _metadataService: MetadataService
  ) {}

  storeTalkingAvatarConfig() {
    const avatarVal = this.avatarConfigForm.value;
    this.subs.push(
      this._metadataService.set(this.getMetadataKey(), JSON.stringify(avatarVal)).subscribe()
    );
  }

  private getMetadataKey() {
    return `${MetadataSlugs.TalkingAvatarSettings}_${this.botItem?._id}`;
  }

  ngOnDestroy() {
    this.subs.forEach(sub => sub.unsubscribe());
  }
}
